import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Opcoes } from 'src/app/models/usuario/opcoes';
import { ProfileService } from 'src/app/service/profile.service';
import { UsuarioService } from 'src/app/service/usuario.service';
import { AppState, selectUsuario } from 'src/app/store';
import { Store } from '@ngrx/store';
import { UsuarioNovo } from 'src/app/store/usuario/usuario.actions';

@Component({
  selector: 'visao-cedente-sacado',
  templateUrl: './visao-cedente-sacado.component.html',
  styleUrls: ['./visao-cedente-sacado.component.scss'],
})
export class VisaoCedenteSacadoComponent implements OnInit {
  exibir = false;
  usuario: any;
  trocarVisao: any;
  perfisHabilitados: string[] = [];

  constructor(
    private router: Router,
    private profileService: ProfileService,
    private usuarioService: UsuarioService,
    private store: Store<AppState>,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.init();
  }

  async init() {
    this.trocarVisao = this.route.snapshot.queryParams['trocarVisao'];

    this.buscaUserLogado();

    if (await this.profileService.temAcessoPortalCedente()) this.perfisHabilitados.push('cedente');
    if (await this.profileService.temAcessoPortalSacado()) this.perfisHabilitados.push('sacado');
    if (await this.profileService.temAcessoPortalInvestidor()) this.perfisHabilitados.push('investidor');

    if (this.perfisHabilitados.length > 1) {
      if (this.trocarVisao) {
        this.exibir = true;
      } else {
        this.requestConfiguser();
      } 
    } else {
      if (this.visaoHabilitada('cedente')) this.visaoCedente();
      if (this.visaoHabilitada('sacado'))  this.visaoSacado();
      if (this.visaoHabilitada('investidor')) this.visaoInvestidor();
    }
  }

  requestConfiguser() {
    this.usuarioService.obterConfigUsuario(this.usuario.id).subscribe(
      (response) => {
        if (response && response.opcoes && response.opcoes.TELA_VISAO) {
          if (response.opcoes.TELA_VISAO == 'CEDENTE') {
            this.visaoCedente(false);
          } else if (response.opcoes.TELA_VISAO == 'SACADO') {
            this.visaoSacado(false);
          } else if (response.opcoes.TELA_VISAO == 'INVESTIDOR') {
            this.visaoInvestidor(false);
          }
        } else {
          this.exibir = true;
        }
      },
      (error) => {
        this.exibir = true;
      }
    );
  }

  visaoCedente(request: boolean = true) {
    if (request) {
      let obj = { TELA_VISAO: 'CEDENTE' };
      this.requestGravaConfigUser(obj);
    }
    
    this.usuario.tipoUsuario = 'CEDENTE';
    this.store.dispatch(new UsuarioNovo({ user: this.usuario }));
    this.router.navigate(['recebiveis/dashboard']);
  }

  visaoSacado(request: boolean = true) {
    if (request) {
      let obj = { TELA_VISAO: 'SACADO' };

      this.requestGravaConfigUser(obj);
    }

    this.usuario.tipoUsuario = 'SACADO';
    this.store.dispatch(new UsuarioNovo({ user: this.usuario }));

    this.router.navigate(['recebiveis/lancamentos']);
  }

  visaoInvestidor(request: boolean = true) {
    if (request) {
      let obj = { TELA_VISAO: 'INVESTIDOR' };

      this.requestGravaConfigUser(obj);
    }

    this.usuario.tipoUsuario = 'INVESTIDOR';
    this.store.dispatch(new UsuarioNovo({ user: this.usuario }));

    this.router.navigate(['investimento/meus-investimentos']);
  }

  visaoHabilitada(visao: string) {
    return this.perfisHabilitados.find(f => f == visao);
  }

  buscaUserLogado() {
    this.store.select(selectUsuario).subscribe((u: any) => {
      this.usuario = u;
    });
  }

  requestGravaConfigUser(dados: any) {
    let obj: Opcoes = {
      idUsuario: this.usuario.id,
      opcoes: dados,
    };

    this.usuarioService.gravarConfigUsuario(obj).subscribe((response) => {});
  }
}
